import $ from 'jquery'
import { detect } from 'detect-browser'

const browser = detect()
const browser_version = browser.version.split('.')
const browser_html_class = browser.name + '-' + browser_version[0]

function initMap() {
	const map_data = JSON.parse(window.map_data)

	generate_map(map_data)
}

function set_map(map, bounds) {
	map.fitBounds(bounds)
	map.initialZoom = true

	window.google.maps.event.addDomListener(window, 'resize', function() {
		map.fitBounds(bounds)
		map.initialZoom = true
	})
}

function get_info_window_template(property) {
	const title = property.acf.alternate_title
		? property.acf.alternate_title
		: property.title.rendered

	const address = []

	property.acf.address ? address.push(property.acf.address) : ''
	property.acf.address_3 ? address.push(property.acf.address_3) : ''
	property.acf.address_2 ? address.push(property.acf.address_2) : ''

	const place = []

	property.acf.city ? place.push(property.acf.city) : ''

	if (property.acf.state.value) {
		property.acf.state.value ? place.push(property.acf.state.value) : ''
	} else {
		property.acf.state ? place.push(property.acf.state) : ''
	}

	property.acf.zipcode ? place.push(property.acf.zipcode) : ''

	const contact_info = []

	property.acf.phone ? contact_info.push('Phone: ' + property.acf.phone) : ''
	property.acf.fax ? contact_info.push('Fax: ' + property.acf.fax) : ''

	const contact_info_rendered = contact_info.length
		? `<p class="info-window-container_contacts">
				${contact_info.join('<br/>')}
			</p>`
		: ''

	return `<div class="info-window-container">
		<p class="info-window-container__title">
			<strong>${title}</strong>
		</p>
		<p class="info-window-container__address">
			${address.join(', <br/>')} <br/>
			${place.join(', ')}
		</p>
		${contact_info_rendered}
	</div>`
}

function generate_map(map_data) {
	const locations = map_data.locations
	const styles = map_data.styles
	const icon = map_data.icon

	const map_element = document.getElementById('locations_map')
	const map = new window.google.maps.Map(map_element, {
		styles: styles,
		mapTypeControl: true,
		mapTypeControlOptions: {
			style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: window.google.maps.ControlPosition.TOP_CENTER,
		},
		zoomControl: true,
		zoomControlOptions: {
			position: window.google.maps.ControlPosition.RIGHT_CENTER,
		},
		scaleControl: true,
		streetViewControl: true,
		streetViewControlOptions: {
			position: window.google.maps.ControlPosition.LEFT_TOP,
		},
		fullscreenControl: true,
	})

	window.google.maps.event.addListener(map, 'zoom_changed', function() {
		const zoomChangeBoundsListener = window.google.maps.event.addListener(
			map,
			'bounds_changed',
			function() {
				if (this.getZoom() > 15 && this.initialZoom == true) {
					// Change max/min zoom here
					this.setZoom(15)
					this.initialZoom = false
				}
				window.google.maps.event.removeListener(
					zoomChangeBoundsListener
				)
			}
		)
	})

	const bounds = new window.google.maps.LatLngBounds()
	const infowindow = new window.google.maps.InfoWindow()

	// Colection of map markers
	const markers = []

	$.each(locations, function(index, location) {
		const latitude = location.acf.latitude
		const longitude = location.acf.longitude

		if (latitude && longitude) {
			if (latitude >= 90 || latitude <= -90) {
				// eslint-disable-next-line no-console
				console.error(
					location.title.rendered +
						' has an out of bounds latitude of ' +
						latitude +
						'.'
				)
			}

			if (longitude >= 180 || longitude <= -180) {
				// eslint-disable-next-line no-console
				console.error(
					location.title.rendered +
						' has an out of bounds longitude of ' +
						longitude +
						'.'
				)
			}

			const marker_args = {
				position: new window.google.maps.LatLng(latitude, longitude),
				optimized: false,
				map: map,
			}

			if (icon) {
				marker_args.icon = {
					url: icon,
				}

				if (browser_html_class === 'ie-11') {
					marker_args.iconscaledSize = new window.google.maps.Size(
						100,
						100
					)
				}
			}

			const marker = new window.google.maps.Marker(marker_args)

			markers.push(marker)

			// Extend the bounds to include each marker's position
			bounds.extend(marker.position)

			// Add descriptions to map markers.
			window.google.maps.event.addListener(
				marker,
				'mouseover',
				(marker => {
					return () => {
						const layout = get_info_window_template(location)

						infowindow.setContent(layout)
						infowindow.open(map, marker)
					}
				})(marker, index)
			)
		}
	})

	// Now fit the map to the newly inclusive bounds
	set_map(map, bounds, markers)
}

window.initMap = initMap
